import React from "react"
import { Modal } from "react-bootstrap"
import HtmlToReactParser from "html-to-react"

import { getMyPromo, searchPromo } from "../../model/promo"

import { commonErr } from "../common/errors"
import { moment, formatPrice } from "../common/common"
import { LoadingInline } from "../common/loading"
import { Empty } from "../common/messagebox"

import { PromoCD, IcPromo } from "../common/svg"

import empty from "../../static/images/empty/empty-promo.svg"

const PromoBox = ({show, onHide, activeCode}) => {
    let htmlToReactParser = new HtmlToReactParser.Parser();
    return (<Modal
        show={show}
        onHide={onHide}
        dialogClassName="modal-s modal-dialog modal-add-promotion">
        <Modal.Header closeButton={true} closeLabel={""}>
            <h5>Mã khuyến mãi</h5>
        </Modal.Header>
        <Modal.Body>
            <div className="add-promotion">
                {activeCode.desc ? <div className="add-promotion__detail"> 
                    <div className="promo-img">
                        <PromoCD />
                    </div>
                    <div className="title"> 
                        <h6>{activeCode.code}</h6>
                    </div>
                    <div className="promotion">
                    <p>Áp dụng từ {moment(activeCode.validDateFrom).format("DD/MM/YYYY")} đến {moment(activeCode.validDateTo).format("DD/MM/YYYY")}</p>
                    </div>
                    {htmlToReactParser.parse(activeCode.desc)}
                </div>
                : <div className="add-promotion__detail">
                    <p>Không có mô tả</p>
                </div>}
            </div>

        </Modal.Body>
    </Modal>)
}

const PromoItem = ({code, showPromoCodeDetail}) => {

    return (
        <div className="promo-item">
            <div className="promo-box"> 
                <div className="img"> 
                    <IcPromo />
                </div>
                <div className="info"> 
                    <strong>{code.code}</strong>
                    {code.discountPercent > 0 ?  
                        <p className="font-12 fontWeight-5">Giảm {code.discountPercent}% {code.discountMax > 0 ? `(tối đa ${formatPrice(code.discountMax)})` : 'Không giới hạn'}</p> 
                        : 
                        <p className="font-12 fontWeight-5">Giảm {formatPrice(code.discountMax)}</p>}
                </div>
                <div className="btn btn--s btn-primary" onClick={() => showPromoCodeDetail(code)}>Xem chi tiết</div>
            </div>
        </div>
    )
}
 

export default class MyPromo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            err: commonErr.INNIT,
            searchCode: ""
        }
    }

    componentDidMount() {
        this.setState({
            err: commonErr.LOADING
        });
        getMyPromo(0, 0, 0).then(myCodeResp => {
            if (myCodeResp.data.error >= commonErr.SUCCESS) {
                const searchCode = this.state.searchCode;
                if (searchCode && searchCode !== "") {
                    searchPromo(searchCode, 0).then(searchResp => {
                        if (searchResp.data.error >= commonErr.SUCCESS) {
                            this.setState({
                                searchCode: searchCode,
                                err: searchResp.data.error,
                                codes: searchResp.data.data.codes,
                                myCodes: myCodeResp.data.data.codes
                            });
                        } else {
                            this.setState({
                                searchCode: searchCode,
                                err: searchResp.data.error,
                                myCodes: myCodeResp.data.data.codes,
                                codes: null
                            });
                        }
                    });
                } else {
                    this.setState({
                        err: myCodeResp.data.error,
                        myCodes: myCodeResp.data.data.codes
                    });
                }
            } else {
                this.setState({
                    err: myCodeResp.data.error,
                    myCodes: null
                });
            }
        });
    }

    onSearchCodeChange = (event) => {
        clearTimeout(this.timer);
        const searchCode = event.target.value;
        this.setState({
            searchCode: searchCode
        });
        this.timer = setTimeout(() => this.searchCode(searchCode), 500);
    }

    searchCode = (searchCode) => {
        if (!searchCode || searchCode === "") {
            return;
        }

        this.setState({
            err: commonErr.LOADING
        });
        searchPromo(searchCode, 0).then(resp => {
            if (resp.data.error >= commonErr.SUCCESS) {
                this.setState({
                    searchCode: searchCode,
                    err: resp.data.error,
                    codes: resp.data.data.codes
                });
            } else {
                this.setState({
                    searchCode: searchCode,
                    err: resp.data.error,
                    codes: null
                });
            }
        });
    }

    showPromoCodeDetail = (code) => {
        this.setState({
            activeCode: code
        });
    }

    hidePromoCodeDetail = () => {
        this.setState({
            activeCode: null
        });
    }

    render() {
        var content;
        const {err, myCodes, codes, searchCode, activeCode} = this.state;

        if (err === commonErr.INNIT || err === commonErr.LOADING) {
            content = <LoadingInline />
        } else if (!searchCode || searchCode === "") {
            if (!myCodes || myCodes.length === 0) {
                content = <Empty img={empty} msg={"Không tìm thấy mã khuyến mãi"} />
            } else {
                content = myCodes.map(code => <PromoItem key={code.id} code={code} showPromoCodeDetail={this.showPromoCodeDetail} />)
            }
        } else {
            if (!codes || codes.length === 0) {
                content = <Empty img={empty} msg={"Không tìm thấy mã khuyến mãi"} />
            } else {
                content = codes.map(code => <PromoItem key={code.id} code={code} showPromoCodeDetail={this.showPromoCodeDetail} />)
            }
        }

        return (<>
                <div className="content-item promo-list">
                    <div className="custom-input">
                        <div className="wrap-input">
                            <input type="text" placeholder="Nhập mã khuyến mãi" value={searchCode} onChange={this.onSearchCodeChange} style={{ textTransform: "uppercase" }} />
                        </div>
                    </div>
                     {/* <div className="form-default">
                            <div className="line-form">
                                <div className="wrap-input has-ico-search"> <i className="ic ic-search"></i>
                                    <input type="text" placeholder="Nhập mã khuyến mãi" value={this.state.searchCode} onChange={this.onSearchCodeChange.bind(this)} />
                                </div>
                            </div>
                        </div> */}
                    {content}
                </div>

                {activeCode && <PromoBox show={activeCode} onHide={this.hidePromoCodeDetail} activeCode={activeCode} />}
              
            </>
        )
    }
}

